var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "for-auto" },
    [
      _c(
        "SectionComponent",
        [
          _c("WrapperComponent", { attrs: { title: "Все для вашего авто" } }, [
            _c(
              "div",
              { staticClass: "for-auto_body" },
              _vm._l(_vm.data, function (item, i) {
                return _c("CarCard", { key: i, attrs: { data: item } })
              }),
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }